<template>
  <div class="project-preview">
    <div class="sticky-cont">
      <v-overlay absolute :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Snackbar for user messages -->
      <v-snackbar v-model="snackbarShow" :color="snackbarColor" top>
        {{ snackbarText }}
        <v-btn dark text @click="snackbarShow = false">Close</v-btn>
      </v-snackbar>

      <v-text-field
        outlined
        hide-details
        label="Nom"
        v-model="localProject.patient.lastname"
        disabled
      ></v-text-field>
      <v-text-field
        outlined
        hide-details
        label="Prénom"
        class="mt-2"
        v-model="localProject.patient.firstname"
        disabled
      ></v-text-field>
      <v-text-field
        outlined
        hide-details
        label="Date"
        class="mt-2"
        :value="localProject.created_at | dateFormat"
        disabled
      ></v-text-field>
      <v-text-field
        outlined
        hide-details
        label="N° Patient"
        class="mt-2"
        v-model="localProject.patient.number"
      ></v-text-field>
      <v-text-field
        outlined
        hide-details
        label="N° Dossier"
        class="mt-2"
        :value="localProject.file_number"
        disabled
      ></v-text-field>
      <v-text-field
        outlined
        hide-details
        label="N° Appareil"
        class="mt-2"
        v-model="localProject.device_number"
      ></v-text-field>
      <v-text-field
        outlined
        hide-details
        label="N° Secu"
        class="mt-2"
        v-model="localProject.patient.nir"
        disabled
      ></v-text-field>
      <v-text-field
        outlined
        hide-details
        label="Type de Fiche"
        class="mt-2"
        :value="getTranslatedProductModel(localProject.product_model)"
        disabled
      ></v-text-field>
      <v-text-field
        outlined
        hide-details
        label="Applicateur"
        class="mt-2"
        :value="getFullname(localProject.applicator)"
        disabled
      ></v-text-field>
      <v-textarea
        filled
        name="Adresse"
        label="Adresse"
        rows="2"
        hide-details
        class="mt-2"
        :value="getFullAddress(localProject.patient)"
        disabled
      ></v-textarea>
      <v-textarea
        filled
        name="Adresse"
        label="Commentaires"
        v-model="localProject.comment"
        rows="5"
        hide-details
        class="mt-2"
      ></v-textarea>
      <div class></div>
      <v-btn class="mt-6" :disabled="!dataModified" @click="update"
        >Enregistrer</v-btn
      >
      <v-btn class="mt-6 ml-1" @click="goToConsultationPage(localProject.uuid)"
        >Consulter</v-btn
      >
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import utils from "@/mixins/utils";

export default {
  name: "ProjectPreview",
  mixins: [utils],
  props: {
    project: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localProject: this.project,

      snackbarShow: false,
      snackbarColor: "success",
      snackbarText: "",

      originalData: ""
    };
  },
  watch: {
    project(newVal) {
      this.localProject = newVal;
      this.originalData =
        this.localProject.patient.number +
        this.localProject.device_number +
        this.localProject.comment;
    }
  },
  computed: {
    dataModified() {
      let localhash =
        this.localProject.patient.number +
        this.localProject.device_number +
        this.localProject.comment;

      return localhash != this.originalData;
    }
  },
  methods: {
    ...mapActions({
      updateProjectLight: "projects/updateProjectLight"
    }),

    // Update project
    async update() {
      try {
        const payload = {
          device_number: this.localProject.device_number,
          patient_number: this.localProject.patient.number,
          lastname: this.localProject.patient.lastname,
          firstname: this.localProject.patient.firstname,
          comment: this.localProject.comment
        };
        await this.updateProjectLight({
          project_uuid: this.localProject.uuid,
          payload: payload
        });

        this.originalData =
          this.localProject.patient.number +
          this.localProject.device_number +
          this.localProject.comment;

        this.snackbarText = "Modification réalisée avec succès";
        this.snackbarColor = "success";
        this.snackbarShow = true;
      } catch (error) {
        this.snackbarText = error;
        this.snackbarColor = "error";
        this.snackbarShow = true;
      }
    },

    // Go to consultation page
    goToConsultationPage(project_uuid) {
      this.$router.push({
        name: "ConsultationPage",
        params: { project_uuid: project_uuid }
      });
    },

    // Return applicator fullname
    getFullname(applicator_object) {
      return applicator_object.lastname + " " + applicator_object.firstname;
    },

    // Return full address
    getFullAddress(patient_object) {
      var p_addr = patient_object.address != null ? patient_object.address : "";
      var p_zipcode =
        patient_object.zipcode != null ? patient_object.zipcode : "";
      var p_city = patient_object.city != null ? patient_object.city : "";

      return `${p_addr} ${p_zipcode} ${p_city}`;
    }
  },
  mounted() {
    this.originalData =
      this.project.patient.number +
      this.project.file_number +
      this.project.device_number;
  }
};
</script>

<style lang="scss">
.project-preview {
  position: relative;
}
</style>
